import React from 'react';
import {
  SubscriptionCallout,
  SubscriptionAccent,
  SubscriptionContent,
} from './Subscription.styles';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { useNavigate } from 'react-router-dom';
const Subscription = () => {
  const navigate = useNavigate();
  return (
    <SubscriptionCallout>
      <SubscriptionAccent>
        <span>No Annual Training Subscription</span>
      </SubscriptionAccent>

      <SubscriptionContent>
        <div>
          <p className="eyebrowHeader">Straightforward Company Training</p>

          <h2>Use the Training Tools Without a Yearly Platform Fee</h2>

          <p>
            There is currently no annual subscription required to use Yoda
            Safety Services company training management. Create your company
            account and purchase the training your team needs when they need it.
          </p>
        </div>
        <PrimaryButton
          functionName={() => navigate('/company-signup')}
          span="Register Your Company"
        />
      </SubscriptionContent>
    </SubscriptionCallout>
  );
};

export default Subscription;
